module.exports = __webpack_public_path__ + "img/ic_exchange.da8fee2b.png";